import { useState } from "react";
import Arrow from "@/components/arrow";
import { useTranslation } from "react-i18next";
import formData from "@/i18n/json/forms/data.json";
import { IProductItem } from "../interfaces/IFormProducts";
// Tailwind Classes
import { wrapper, valueContainer, productList, productItem } from "../styles/product-of-interest";

const ProductOfInterest: React.FC<{ onSelectHandler: (item: string) => void }> = ({ onSelectHandler }) => {
    const { t } = useTranslation();
    const [showList, setShowList] = useState(false);
    const [product, setProduct] = useState("");

    const products: IProductItem[] = formData.products;

    const showListHandler = () => {
        setShowList(!showList);
    };

    return (
        <div className={wrapper}>
            <div
                className={valueContainer}
                onClick={() => {
                    showListHandler();
                }}
            >
                <p>{product === "" ? t("forms.get-in-touch.product-of-interest") : product}</p>
                <Arrow dir="down" size={2} />
            </div>
            {showList && (
                <div className={productList}>
                    <ul>
                        {products.map((item: IProductItem, index: number) => {
                            return (
                                <li
                                    key={index}
                                    className={productItem}
                                    onClick={() => {
                                        onSelectHandler(item.value);
                                        showListHandler();
                                        setProduct(item.label);
                                    }}
                                >
                                    {item.label}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default ProductOfInterest;
